import { Module } from 'vuex'

import { RootState } from '@/store/types'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { PaymentState } from './types'

const paymentModule: Module<PaymentState, RootState> = {
  namespaced: true,
  actions,
  mutations,
  getters,
  state: {
    paymentPageData: {
      firstName: '',
      lastName: '',
      street: '',
      houseNumber: '',
      postcode: '',
      city: '',
      additionalAddressInformation: '',
    },
  },
}

export default paymentModule
